<soft-page>
  @if (
    {
      item: (item$ | async),
      price: (price$ | async),
      stock: (stock$ | async),
      details: (details$ | async),
      pricelist: (pricelist$ | async),
      config: (config$ | async),
    };
    as data
  ) {
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-2 lg:gap-3 lg:flex-row items-start mt-4">
        @if (data?.item?.thumbnail | media; as thumbnail) {
          @if (data?.item?.thumbnail && thumbnail) {
            <div
              class="w-full lg:w-1/4 aspect-square border border-solid border-separator rounded overflow-hidden bg-surface cursor-pointer shrink-0"
              (click)="openImageDialog(thumbnail)"
            >
              <img [src]="thumbnail" class="w-full h-full object-cover" alt="thumbnail" />
            </div>
          }
        } @else {
          <div
            class="w-full lg:w-1/4 aspect-square border border-solid border-separator rounded bg-surface flex flex-col items-center justify-center shrink-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-10 h-10 text-slate-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.587-1.587a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span class="text-xs text-slate-400 mt-2 font-medium">Kein Bild</span>
          </div>
        }

        <div
          class="flex flex-col w-full gap-2"
          [ngClass]="data?.item?.thumbnail ? 'lg:w-3/4' : ''"
        >
          <div class="grid grid-cols-3 gap-2">
            <div
              class="flex flex-col px-3 py-2 border border-solid border-separator rounded bg-surface"
            >
              <span class="text-sm font-medium text-light">
                {{ '#ARTIKELINFO.PAGES.DETAIL.ITEM_NUMBER' | translate }}
              </span>
              <span class="text-base font-semibold mb-0">{{ data.item?.number }}</span>
            </div>
            <div
              class="flex flex-col px-3 py-2 border border-solid border-separator rounded bg-surface"
            >
              <span class="text-sm font-medium text-light"> EAN </span>
              <span class="text-base font-semibold mb-0">
                {{ data.item?.ean ?? 'nicht angegeben' }}
              </span>
            </div>
            <div
              class="flex flex-col px-3 py-2 border border-solid border-separator rounded bg-surface"
            >
              <span class="text-sm font-medium text-light"> Matchcode </span>
              <span class="text-base font-semibold mb-0">
                {{ data.item?.matchcode ?? 'nicht angegeben' }}
              </span>
            </div>
          </div>

          @for (title of TITLES; track $index) {
            @if (data.item?.['title' + ($index + 1)]) {
              <div
                class="flex flex-col px-3 py-2 border border-solid border-separator rounded bg-surface"
              >
                <span class="text-sm font-medium text-light">
                  {{ '#ARTIKELINFO.PAGES.DETAIL.ARTBEZ' + ($index + 1) | translate }}
                </span>

                <span class="text-base font-semibold mb-0">
                  {{ data.item?.['title' + ($index + 1)] }}
                </span>
              </div>
            }
          }
        </div>
      </div>

      <!--price list-->
      @if (
        data?.pricelist &&
        data?.pricelist?.tieredPricelist &&
        (data?.pricelist?.tieredPricelist?.length ?? 0) > 0
      ) {
        <soft-price-list [data]="data.pricelist"></soft-price-list>
      }
      <!---->

      <!--listung-->
      @if (!data?.config?.hideListung) {
        <soft-listung
          [data]="data.details"
          [expanded]="data?.config?.listungExpanded || false"
        ></soft-listung>
      }
      <!---->

      <!--lagerstände-->
      @if (!data?.config?.hideLagerstaende) {
        @if (data?.stock; as stock) {
          <soft-lagerstaende
            [data]="stock"
            [expanded]="data?.config?.lagerstaendeExpanded || false"
            [showNextOrderDate]="data?.config?.showNextOrderDate || false"
            (showBewegungen)="showBewegungen($event.stockLocation, data.item)"
          >
          </soft-lagerstaende>
        }
      }
      <!---->

      <!--details - lagerplätze, einheiten, lieferanten-->
      @if (data?.details; as details) {
        <soft-details
          [data]="details"
          [hideLagerplaetze]="data?.config?.hideLagerplaetze || false"
          [hideEinheiten]="data?.config?.hideEinheiten || false"
          [hideLieferanten]="data?.config?.hideLieferanten || false"
          [lagerplaetzeExpanded]="data?.config?.lagerplaetzeExpanded || false"
          [einheitenExpanded]="data?.config?.einheitenExpanded || false"
          [lieferantenExpanded]="data?.config?.lieferantenExpanded || false"
        ></soft-details>
      }
      <!---->

      <!--offene bestellungen-->
      @if (!data?.config?.hideOffeneBestellungen) {
        @if (data?.stock; as stock) {
          @if ((stock?.orders || 0) > 0) {
            <div class="flex flex-col mt-5">
              <h6
                class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide"
              >
                {{ '#ARTIKELINFO.PAGES.DETAIL.OPEN_ORDERS.TITLE' | translate }}
              </h6>
              <div
                class="full-width flex flex-col bg-surface border-t border-t-solid border-t-separator"
              >
                <div
                  class="flex px-4 py-2 items-center justify-between w-full border-b border-b-solid border-b-separator bg-surface-secondary"
                >
                  <div class="text-[0.825rem] font-semibold">
                    {{ '#ARTIKELINFO.PAGES.DETAIL.OPEN_ORDERS.STOCK' | translate }}
                  </div>
                  <div
                    class="text-[0.825rem] font-semibold flex items-center justify-end text-right"
                  >
                    {{ '#ARTIKELINFO.PAGES.DETAIL.OPEN_ORDERS.OPEN_AMOUNT' | translate }}
                  </div>
                </div>
                @for (stockEntry of stock.stockAmount; track stockEntry) {
                  @if (stockEntry?.orders && (stockEntry?.orders || 0) > 0) {
                    <div
                      class="flex px-4 py-3 items-center justify-between w-full border-b border-b-solid border-b-separator"
                    >
                      <div class="flex items-center gap-2">
                        <div
                          (click)="showBewegungen(stockEntry, data.item)"
                          class="border border-primary bg-primary-50 hover:bg-primary-100 text-primary rounded-full p-3 cursor-pointer"
                        >
                          <soft-icon name="fa-regular fa-clipboard-list"></soft-icon>
                        </div>
                        <div>{{ stockEntry.stock?.title || stockEntry.stock?.name }}</div>
                      </div>
                      <div class="font-semibold flex items-center justify-end text-right">
                        {{ stockEntry.orders | number: '1.2-2' }}
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
      }
      <!---->

      <!--umsatzabfrage-->
      @if (!data?.config?.hideUmsatzabfrage) {
        @if (umsaetze$ | async; as umsaetze) {
          @if (params()?.showUmsatzabfrage) {
            <soft-umsatzabfrage
              [data]="umsaetze"
              [umsatzabfrageFilialen]="umsaztabfrageFilialen$ | async"
              [selectedUmsatzabfrageViewIndex]="selectedUmsatzabfrageViewIndex$ | async"
              [item]="item$ | async"
              [sum]="sum$ | async"
              [umsatzabfrageForm]="umsatzabfrageForm"
              (formSubmit)="onSubmit(data.item)"
              (tabIndexChanged)="onTabIndexChanged($event)"
            ></soft-umsatzabfrage>
          }
        }
      }
      <!---->
    </div>
  }
</soft-page>
<ng-template #menuBarTemplate>
  <div class="flex items-center gap-1.5">
    <soft-menu-bar-button
      [icon]="'fa-regular fa-heart'"
      [label]="'Zu Favoriten hinzufügen'"
      [tooltip]="'Zu Favoriten hinzufügen'"
      [variant]="'primary'"
      (execute)="addFavorite()"
    ></soft-menu-bar-button>
    <soft-menu-bar-button
      [icon]="'fa-regular fa-barcode-read'"
      [label]="'Scannen'"
      [tooltip]="'Scannen'"
      [variant]="'outline'"
      (execute)="scan()"
    ></soft-menu-bar-button>
  </div>
</ng-template>
